import * as React from "react";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { Navigate, useSearchParams } from "react-router";
import { AuthenticationView } from "./authentication";
import { getLoginRedirectPath } from "./redirectState";
import { warmAuth, warmMainwebForReturningUser } from "@/helpers/warmup";

export const LoginView: React.FC = () => {
  const user = useAuthenticatedUser();
  const [searchParams] = useSearchParams();
  const redirectPath = getLoginRedirectPath(searchParams.get("state"));

  React.useEffect(() => {
    warmAuth();
    warmMainwebForReturningUser();
  }, []);

  if (user.isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return <AuthenticationView />;
};
